// extracted by mini-css-extract-plugin
module.exports = {"image":"wv-z","loaded":"xv-z","placeholder":"yv-z"};